import { ShipyardService } from 'src/app/modules/shipyard/shipyard.service';
import { Router } from "@angular/router";
import { FormControl } from "@angular/forms";
import { Component, Inject, OnDestroy, OnInit } from "@angular/core";
import {  MatDialog,  MatDialogRef,  MAT_DIALOG_DATA,} from "@angular/material/dialog";
import { OnboardingService } from "src/app/services/onboarding.service";
import { DialogActions } from "src/app/components/dialogs/dialog.model";
import { GridActionsService } from "src/app/data-grid/grid-actions.service";
import { AuthService } from 'src/app/services/auth.service';
import { filter, takeUntil } from "rxjs/operators";
import { CreateSellerCentralShipmentsComponent } from "../create-seller-central-shipments/create-seller-central-shipments.component";
import { LoginModel } from './../../../models/login.model';
import { Subject } from 'rxjs';

@Component({
  selector: "app-upgrade-feemium-dialog",
  templateUrl: "./upgrade-feemium-dialog.component.html",
  styleUrls: ["./upgrade-feemium-dialog.component.scss"],
})
export class UpgradeFeemiumDialogComponent implements OnInit, OnDestroy {
  actions: DialogActions[] = [
    {
      text: "Pay Now",
       spin:false
    },
  ];
  hideCloser = false;
  tabIndex: number = 0;
  radio: FormControl = new FormControl(1);
  lastFour: string;
  ccName: string;
  responseMessage: string;
  error: boolean = false;
  userInfo: LoginModel;
  private destroy$ = new Subject<void>();

  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    public dialogRef: MatDialogRef<UpgradeFeemiumDialogComponent>,
    private onboardingService: OnboardingService,
    private router: Router,
    private dialog: MatDialog,
    private gridActionService: GridActionsService,
    private authService: AuthService,
    private shipyardService: ShipyardService
  ) {}

  ngOnInit(): void {
    this.onboardingService.GetCreditCards().pipe(takeUntil(this.destroy$)).subscribe((e: any) => {
      this.lastFour = e[0]?.last4;
      this.ccName = e[0]?.name;
    });

    if (this.data && this.data.addtionalActions) {
      if (this.data.addtionalActions.text === "Go Back") {
        this.hideCloser = true;
      }
      this.actions.unshift(this.data.addtionalActions);
    }

    this.authService.userInfo$
    .pipe(filter((e) => (e ? true : false)))
    .subscribe((res) => {
      this.userInfo = res;
    });
  }

  upgradeToPremium() {
    this.data?.addtionalActions ? this.actions[1].spin = true : this.actions[0].spin = true;
    this.onboardingService.UpgradeToPremium().pipe(takeUntil(this.destroy$)).subscribe({
      next: (e:any) => {
        if (e.success) {
          this.tabIndex = 1;
          this.shipyardService.updateLocalStorageKey("isShipyard", 2);
          this.continue();
          this.responseMessage = 'Upgrade Successful';
        } else {
          this.upgradeFailed(e.error || 'Upgrade Failed: Please check your credit card and try again');
        }      
        this.data?.addtionalActions ? this.actions[1].spin = false :this.actions[0].spin = false;
      },
     error: (err) => {
      this.upgradeFailed('Upgrade Failed: Please check your credit card and try again');      
      this.data?.addtionalActions ? this.actions[1].spin = false :this.actions[0].spin = false;
     }
   });
  } 

  upgradeFailed(message?: string) {
    this.responseMessage = message;
    this.error = true;
    this.billing();
    this.tabIndex = 1;
  }

  purchaseAdditionalCredit() {
    this.data?.addtionalActions ? this.actions[1].spin = true :this.actions[0].spin = true;
    this.onboardingService.PurchaseFreemiumCredit().pipe(takeUntil(this.destroy$)).subscribe({
      next: (e:any) => {
        if (e.success) {
          this.tabIndex = 1;
          if (!this.hideCloser) {
            this.shipyardService.updateLocalStorageKey("freemiumAvail", true);
          }
          this.continue();
          this.responseMessage = 'Credit processed';
        } else {
          this.purchaseAdditionalCreditError();
        }
        this.data?.addtionalActions ? this.actions[1].spin = false :this.actions[0].spin = false;
      },
     error: (err) => {
      this.purchaseAdditionalCreditError();
      this.data?.addtionalActions ? this.actions[1].spin = false :this.actions[0].spin = false;
     }
   });
  }

  purchaseAdditionalCreditError(): void {
    this.responseMessage = 'Credit processing failed: Please check your credit card and try again';
    this.error = true;
    this.billing();
    this.tabIndex = 1;
  }

  continue() {
    this.actions = [
      {
        text: "Continue",
      }
    ]
  };

  billing() {
    this.actions = [
      {
        text: "Billing",
      }
    ]
  }

  upgrade() {
    if (this.radio.value === 1) {
      this.upgradeToPremium();
    } else {
      this.purchaseAdditionalCredit();
    }
  }

  action(e) {
    if (e === "Pay Now") {
      this.upgrade();
    } else if (e === "Go Back") {
      this.router.navigate(["/shipyard/shipments/"]);
      this.dialogRef.close();
    } else if (e === "Submit plan to seller central for free") {
      this.dialogRef.close();
      this.createSellerCentralShipments();
    } else if (e === "Continue") {
      this.dialogRef.close("Continue");
    } else if (e === "Billing") {
      this.dialogRef.close();
      this.router.navigate(['/settings/billing']);
    }
  }

  createSellerCentralShipments() {
    this.dialog
      .open(CreateSellerCentralShipmentsComponent, {
        width: "500px",
        data: {},
      })
      .afterClosed()
      .subscribe((e: any) => {
        if (e && e.type) {
          this.gridActionService.createNewWarehouse(e.type);
        }
      });
  }

  close() {
    this.dialogRef.close();
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }
}
